export const FETCH_SCHEMES_PLAN_SUBOPTION_REQUEST = "FETCH_SCHEMES_PLAN_SUBOPTION_REQUEST";
export const FETCH_SCHEMES_PLAN_SUBOPTION_SUCCESS = "FETCH_SCHEMES_PLAN_SUBOPTION_SUCCESS";
export const FETCH_SCHEMES_PLAN_SUBOPTION_FAILURE = "FETCH_SCHEMES_PLAN_SUBOPTION_FAILURE";
